import React from "react";
import { useTranslation } from "react-i18next";
import { MenuItem } from "@mui/material";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

import { Select } from "Components/Form";
import { colors } from "@zapalacorp/tokens";

import {
  PaginationWrapper,
  PaginationDisplayQuantityWrapper,
  PaginationDisplayQuantity,
  PaginationButtons,
  PaginationNavCluster,
  PaginationNavIconButton,
  PaginationCurrentPageDisplay,
} from "./styles";

interface PaginationProps {
  itemQuantity: number;
  currentDisplay: number;
  setCurrentDisplay: (display: number) => void;
  currentPage: number;
  setCurrentPage: (page: number) => void;
}

export function BingoSheetPagination(props: PaginationProps) {
  const { t: translate } = useTranslation();
  const {
    itemQuantity,
    currentDisplay = 100,
    setCurrentDisplay,
    currentPage,
    setCurrentPage,
  } = props;

  const quantityOfPages = Math.max(1, Math.ceil(itemQuantity / currentDisplay));
  const displayOptions = [100, 200, 300];
  const startIndex = 1 + (currentPage - 1) * currentDisplay;
  const endIndex = Math.min(currentPage * currentDisplay, itemQuantity);

  return (
    <PaginationWrapper>
      <PaginationDisplayQuantityWrapper>
        <span>
          {translate("showing")} {startIndex} - {endIndex} {translate("of").toLowerCase()}{" "}
          {itemQuantity} {translate("items")}
        </span>
        <span>|</span>
        <PaginationDisplayQuantity>
          <span>{translate("display")}</span>
          <Select
            value={currentDisplay}
            onChange={(event) => setCurrentDisplay(Number(event.target.value))}
          >
            {displayOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </PaginationDisplayQuantity>
        <span>{translate("items")}</span>
      </PaginationDisplayQuantityWrapper>
      <PaginationButtons>
        <PaginationNavCluster>
          <PaginationNavIconButton
            type="button"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
            aria-label={translate("previous")}
          >
            <FiChevronLeft size={20} color={colors.gray600} />
          </PaginationNavIconButton>
          <PaginationCurrentPageDisplay aria-current="page">
            {currentPage} / {quantityOfPages}
          </PaginationCurrentPageDisplay>
          <PaginationNavIconButton
            type="button"
            disabled={currentPage === quantityOfPages}
            onClick={() => setCurrentPage(currentPage + 1)}
            aria-label={translate("next")}
          >
            <FiChevronRight color={colors.gray600} size={20} />
          </PaginationNavIconButton>
        </PaginationNavCluster>
      </PaginationButtons>
    </PaginationWrapper>
  );
}
